import ctl from "@netlify/classnames-template-literals";

const wrapperBaseLight = ctl(`
  bg-neutral-50
  items-center
  flex
  rounded-xl
`);

const wrapperBaseDark = ctl(`
  bg-status-info-400
  items-center
  flex
  rounded-2xl
`);

export const wrapper = ctl(`
  ${wrapperBaseLight}
  p-4
`);

export const wrapperSm = ctl(`
  ${wrapperBaseLight}
  p-2
`);

export const wrapperDark = ctl(`
  ${wrapperBaseDark}
  p-4
`);

export const wrapperDarkSm = ctl(`
  ${wrapperBaseDark}
  p-2
`);

export const content = ctl(`
  flex
  flex-row
  space-x-2
`);

export const cta = ctl(`
  text-left
  text-sm
  font-medium
  text-neutral-600
  underline
  whitespace-nowrap
`);
